/* ──────────────────────────────────────────────
   Cookie consent
   The visitor's choice is kept in localStorage under
   `pb2b_consent` (strictly necessary) and asked again
   after six months. HubSpot analytics only loads after
   an explicit opt-in.
   ────────────────────────────────────────────── */
const CONSENT_KEY = "pb2b_consent";
const CONSENT_VERSION = 1;
const CONSENT_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 182; // ~6 months

const HUBSPOT_COOKIES = ["__hstc", "hubspotutk", "__hssc", "__hssrc", "messagesUtk"];

export function readConsent() {
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const consent = JSON.parse(raw);
    const age = Date.now() - Date.parse(consent.ts);
    if (consent.v === CONSENT_VERSION && age >= 0 && age < CONSENT_MAX_AGE_MS) return consent;
    // Expired or from an older version: forget it so we ask again
    window.localStorage.removeItem(CONSENT_KEY);
  } catch (_) { /* unreadable or blocked storage — treat as no choice */ }
  return null;
}

export function writeConsent(analytics) {
  const consent = { v: CONSENT_VERSION, analytics: Boolean(analytics), ts: new Date().toISOString() };
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch (_) { /* storage blocked — the choice applies to this visit only */ }
  return consent;
}

const hubSpotConsent = (analytics) => ({ analytics, advertisement: false, functionality: false });

export function loadHubSpot(portalId) {
  if (document.getElementById("hs-script-loader")) return;
  // Our banner is the consent mechanism, so HubSpot's own banner stays off and
  // we pass the choice on. HubSpot doesn't remember it, so this runs on every load.
  window.disableHubSpotCookieBanner = true;
  (window._hsp = window._hsp || []).push(["setHubSpotConsent", hubSpotConsent(true)]);
  const script = document.createElement("script");
  script.id = "hs-script-loader";
  script.type = "text/javascript";
  script.async = true;
  script.defer = true;
  script.src = `https://js-eu1.hs-scripts.com/${portalId}.js`;
  document.head.appendChild(script);
}

/* Withdrawal while HubSpot is running on this page: tell it to stop and drop its cookies */
export function stopHubSpot() {
  const hsp = (window._hsp = window._hsp || []);
  hsp.push(["setHubSpotConsent", hubSpotConsent(false)]);
  hsp.push(["revokeCookieConsent"]);
}

export const isHubSpotLoaded = () => Boolean(document.getElementById("hs-script-loader"));

export function reloadPage() {
  window.location.reload();
}

export function removeHubSpotCookies() {
  const parts = window.location.hostname.split(".");
  const domains = [""];
  for (let i = 0; i < parts.length - 1; i++) domains.push(`; domain=.${parts.slice(i).join(".")}`);
  HUBSPOT_COOKIES.forEach((name) => {
    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain}`;
    });
  });
}
